import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import axios from 'axios';

function isTokenValid(token) {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch (e) {
    return false;
  }
}

//axios defaults and interceptor initialization
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.interceptors.request.use(async req => {
  let token = localStorage.getItem('token');
  if (!isTokenValid(token)) {
    if (window.msalInstance && window.msalAccount) {
      try {
        const res = await window.msalInstance.acquireTokenSilent({
          scopes: [process.env.REACT_APP_SCOPE],
          account: window.msalAccount
        });
        token = res.accessToken;
        localStorage.setItem('token', token);
      } catch (e) {
        // Redirect to login if silent refresh fails
        window.msalInstance.loginRedirect({
          scopes: [process.env.REACT_APP_SCOPE]
        });
        return Promise.reject(e);
      }
    }
  }
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// Add a response interceptor to handle 401 errors and retry once
axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      if (window.msalInstance && window.msalAccount) {
        try {
          const res = await window.msalInstance.acquireTokenSilent({
            scopes: [process.env.REACT_APP_SCOPE],
            account: window.msalAccount
          });
          const token = res.accessToken;
          localStorage.setItem('token', token);
          originalRequest.headers['Authorization'] = `Bearer ${token}`;
          return axios(originalRequest);
        } catch (e) {
          // Redirect to login if silent refresh fails
          window.msalInstance.loginRedirect({
            scopes: [process.env.REACT_APP_SCOPE]
          });
          return Promise.reject(e);
        }
      }
    }
    return Promise.reject(error);
  }
);
//create theme
const theme = createTheme({
  typography:{
    fontFamily:  `"open-sans",sans-serif`
  }
})

//msal-instance initialization
const pca = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: "https://login.microsoftonline.com/5b2a8fee-4c95-4bdc-8aae-196f8aacb1b6",
    redirectUri: window.location.origin // Use the app's base URL for redirect
  }
});

// Set msalAccount on app load and after every redirect
function setMsalAccount(expectedUsername) {
  const accounts = window.msalInstance.getAllAccounts();
  console.log('MSAL accounts:', accounts);
  console.log('Expected username:', expectedUsername);
  if (accounts && accounts.length > 0) {
    let selected = accounts[0];
    if (expectedUsername) {
      const found = accounts.find(acc => acc.username === expectedUsername);
      if (found) selected = found;
    }
    window.msalAccount = selected;
    localStorage.setItem('msalUsername', window.msalAccount.username);
    console.log('Selected MSAL account:', window.msalAccount);
  }
}

// MSAL v3+ requires explicit initialization before use
(async () => {
  await pca.initialize();
  window.msalInstance = pca;
  await pca.handleRedirectPromise();
  setMsalAccount(localStorage.getItem('msalUsername'));
  
  // If no MSAL account is found after initialization and redirect, trigger login
  if (!window.msalAccount) {
    console.log('No MSAL account found after init, triggering loginRedirect');
    window.msalInstance.loginRedirect({
      scopes: [process.env.REACT_APP_SCOPE]
    });
    return; // Prevent further rendering until login completes
  }

  // Listen for msal:handleRedirectEnd event to re-set account after login redirect
  window.addEventListener('msal:handleRedirectEnd', () => setMsalAccount(localStorage.getItem('msalUsername')));

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render( 
      <ThemeProvider theme={theme}>
        <App msalInstance={pca} />
      </ThemeProvider>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
})();
